import Rest from '../rest'


/**
 * @type {PowerBi}
 */
export default class PowerBi extends Rest {

    constructor () {
        super('fastreports/powerbi/')
    }
    reports(report) {
        return this.http.get(this.constructor.normalize(this.resource, report))
    }
    launchDay() {
        return this.http.get('/launchday')
    }
}